module.exports = __webpack_public_path__ + "static/img/5.2e49d07.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/9/eng/5.png
// module id = 2EgN
// module chunks = 0